import {Refresh} from '@mui/icons-material';
import {Box, Button, Stack, Typography} from '@mui/material';
import useGetFeatureUsageQuota from '../../../hook/useGetFeatureUsageQuota';
import FeatureUsageRow from './FeatureUsageRow';

export default function FeatureUsage() {
  const {data: featureUsage, refetchFeatureUsageQuota: refetchFeatureUsage} = useGetFeatureUsageQuota();

  return (
    <Stack spacing={3}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h5">Feature Usage</Typography>
        <Button variant="outlined" startIcon={<Refresh />} onClick={() => refetchFeatureUsage()}>
          Refresh
        </Button>
      </Box>
      {featureUsage.length === 0 ? (
        <Typography>No usage data found.</Typography>
      ) : (
        <Stack spacing={2}>
          {featureUsage.map((usage) => (
            <FeatureUsageRow key={usage.id} name={usage.id} value={usage.usage} quota={usage.quota} />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
